import { Property } from 'csstype'

import { Button } from '@thg-commerce/gravity-elements'
import { Tags, TextStyling } from '@thg-commerce/gravity-patterns'
import { Grid, GridItem } from '@thg-commerce/gravity-system'
import { css, spacing, styled, Text } from '@thg-commerce/gravity-theme'

export const ProductRatingContainer = styled(Grid)`
  margin-bottom: ${spacing(3)};
  overflow: auto;
  grid-gap: 0;
`

export const NumberOfReviews = styled.p<{ textStyle?: TextStyling }>`
  margin: ${spacing(1)} 0 ${spacing(3)} 0;

  ${(props) => css`
    ${Text(
      props.textStyle?.entry || 'bodyText',
      props.textStyle?.style || 'alternate',
    )};
    text-decoration: ${props.textStyle?.textDecoration || 'none'};
    ${props.textStyle?.textColor ? `color: ${props.textStyle?.textColor};` : ''}
  `}
`

export const ReviewAndBreakdownWrapper = styled(GridItem)`
  display: flex;
  flex-direction: column;
  justify-content: revert;
  margin-bottom: ${spacing(3)};
`

export const StarContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`

export const StarBreakdownWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-right: ${spacing(1)};
`

export const RatingElementsContainer = styled.div`
  width: 100%;
  height: 100%;
`

export const RatingElement = styled.div`
  display: flex;
  align-items: center;
  padding: ${spacing(0.5)} 0;
`

export const ReviewIndex = styled.p<{ textStyle?: TextStyling }>`
  flex-basis: 10px;
  margin-right: ${spacing(1)};

  ${(props) => css`
    ${Text(
      props.textStyle?.entry || 'bodyText',
      props.textStyle?.style || 'alternate',
    )};
    text-decoration: ${props.textStyle?.textDecoration || 'none'};
    ${props.textStyle?.textColor ? `color: ${props.textStyle?.textColor};` : ''}
  `}
`

export const ReviewsCount = styled.p<{ textStyle?: TextStyling }>`
  ${(props) => css`
    ${Text(
      props.textStyle?.entry || 'bodyText',
      props.textStyle?.style || 'default',
    )};
    text-decoration: ${props.textStyle?.textDecoration || 'none'};
    ${props.textStyle?.textColor ? `color: ${props.textStyle?.textColor};` : ''}
  `}
`

export const StarWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
`

export const SimpleBar = styled.div<{
  filterReviewsByScore?: boolean
  colorFills?: {
    active?: Property.Color
    inactive?: Property.Color
    hover?: Property.Color
  }
  backgroundColor?: Property.Color
}>`
  display: block;
  width: 100%;
  padding: 0;
  margin: 0 ${spacing(1)} 0 ${spacing(1)};
  background-color: ${(props) =>
    props.backgroundColor || props.theme.colors.palette.greys.light};

  ${(props) =>
    props.filterReviewsByScore &&
    `
        :hover div {
          background-color: ${
            props.colorFills?.hover || props.theme.colors.palette.brand.light
          };
        }
        :focus {
          outline: ${
            props.colorFills?.hover || props.theme.colors.palette.brand.light
          } solid 2px;
          border: 1px solid ${props.theme.colors.palette.greys.white};
      
          div {
            background-color: ${
              props.colorFills?.hover || props.theme.colors.palette.brand.light
            };
          }
        }
  `}
`

export const StyledBar = styled.div<{
  barWidth: number
  isSelected?: boolean
  colorFills?: {
    active: Property.Color
    inactive: Property.Color
    hover: Property.Color
  }
  fill: Property.Color
}>`
  width: ${(props) => `${props.barWidth}%`};
  height: ${spacing(2)};

  background-color: ${(props) =>
    props.colorFills
      ? props.isSelected
        ? props.colorFills.active
        : props.colorFills.inactive
      : props.fill || props.theme.colors.palette.brand.base};
`

export const AverageFeatureRatingsTitle = styled.p`
  ${Text('medium1', 'alternate')};
  margin-bottom: ${spacing(1)};
`

export const ButtonsWrapper = styled(GridItem)`
  display: inline-flex;
  flex-direction: column;
`

export const ViewAllReviewsButton = styled(Button)<{ border?: Property.Color }>`
  min-width: fit-content;
  width: 60%;
  justify-content: left;
  margin: 0 0 ${spacing(2)} 0;
`

export const CreateReviewButton = styled(Button)<{ border?: Property.Color }>`
  min-width: fit-content;
  width: 60%;
  justify-content: left;
`

export const StyledProductTags = styled(Tags)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: ${spacing(2)};

  span {
    ${Text('small', 'default')}
    align-items: center;
    padding: ${spacing(0.75)} ${spacing(1.625)} ${spacing(0.75)} ${spacing(2)};
    border-radius: 25px;

    ${(props) => props.colors?.textColor && `color: ${props.colors.textColor}`};
  }
`
